export class GeneralConstants {
    public static readonly PAGE_SIZE_TINY = 5;
    public static readonly PAGE_SIZE_SMALL = 10;
    public static readonly PAGE_SIZE_NORMAL = 25;
    public static readonly PAGE_SIZE_LARGE = 100;
    public static readonly PAGE_SIZE_HUGE = 1000;
    public static readonly PAGE_SIZE_ENORMOUS = 5000;
    public static readonly COLUMN_WIDHT_EM = 25;

    public static readonly PAGE_SIZE_OPTIONS: number[] = [
        GeneralConstants.PAGE_SIZE_TINY,
        GeneralConstants.PAGE_SIZE_SMALL,
        GeneralConstants.PAGE_SIZE_NORMAL,
        GeneralConstants.PAGE_SIZE_LARGE,
        GeneralConstants.PAGE_SIZE_HUGE,
    ];

    public static readonly GRID_SPACING_NORMAL = 3;
    // grid is based on 12 columns
    public static readonly GRID_SPAN_FULL = 12;
    public static readonly GRID_SPAN_HALF = 6;
    public static readonly GRID_SPAN_QTR = 3;
    public static readonly GRID_SPAN_SINGLE = 1;

    public static readonly SHORT_ID_LENGTH = 8;

    // react requires render to return null
    // eslint-disable-next-line no-null/no-null
    public static readonly RENDER_NOTHING = null;

    // some react components are break when undefined is used, just use this in those cases
    // eslint-disable-next-line no-null/no-null
    public static readonly COMPONENT_VALUE_NULL = null;

    public static readonly NULL_FIELD_VALUE = '__N_U_L_L__';
    public static readonly NULL_FIELD_DISPLAY = '(NULL_FIELD)';
}
